const pageNameKey = "logoutTimer";

export const logoutTimerEn = {
  [pageNameKey]: {
    warning:
      "Your session is about to expire. Please save your work or extend your session by moving your mouse.",
  },
};

export const logoutTimerPtBr = {
  [pageNameKey]: {
    warning:
      "Sua sessão está prestes a expirar. Salve seu trabalho ou estenda sua sessão movendo o mouse.",
  },
};

export const logoutTimerDe = {
  [pageNameKey]: {
    warning:
      "Ihre Sitzung läuft in Kürze ab. Bitte speichern Sie Ihre Arbeit oder verlängern Sie Ihre Sitzung, indem Sie Ihre Maus bewegen.",
  },
};

export const logoutTimerZhHans = {
  [pageNameKey]: {
    warning: "您的会话即将过期。请保存您的工作或通过移动鼠标来延长会话。",
  },
};

export const logoutTimerIt = {
  [pageNameKey]: {
    warning:
      "La tua sessione sta per scadere. Per favore salva il tuo lavoro o estendi la sessione spostando il mouse.",
  },
};

export const logoutTimerEs = {
  [pageNameKey]: {
    warning:
      "Tu sesión está a punto de expirar. Guarda tu trabajo o amplía tu sesión moviendo el ratón.",
  },
};

export const logoutTimerNl = {
  [pageNameKey]: {
    warning:
      "Uw sessie verloopt binnenkort. Sla uw werk op of verleng uw sessie door uw muis te bewegen.",
  },
};

export const logoutTimerTr = {
  [pageNameKey]: {
    warning:
      "Oturumunuzun süresi dolmak üzere. Lütfen çalışmanızı kaydedin veya farenizi hareket ettirerek oturumunuzu uzatın.",
  },
};
